<template>
    <footer>
        <div class='p-3 m-0 h5 text-center'>
        </div>
        <ul class='navbar-nav p-0 d-flex flex-column flex-sm-row justify-content-center'>
            <li class='nav-item py-0 px-2 text-center'>
                <a class='nav-link' href='https://www.isbe.net/Pages/Agency-and-Board-Information.aspx'>Agency
                    Information</a>
            </li>
            <li class='nav-item py-0 px-2 text-center'>
                <a href='https://twitter.com/ISBEnews' title='twitter' class='nav-link'>
                    <i class='fab fa-twitter'></i>
                    <span class="d-inline d-sm-none">&nbsp;Twitter</span>
                </a>
            </li>
            <li class='nav-item py-0 px-2 text-center'>
                <a href='https://www.facebook.com/pages/Illinois-State-Board-of-Education/136022251779' title='facebook'
                    class='nav-link'>
                    <i class='fab fa-facebook-f'></i>
                    <span class="d-inline d-sm-none">&nbsp;Facebook</span>
                </a>
            </li>
            <li class='nav-item py-0 px-2 text-center'>
                <a class='nav-link' href='https://www.isbe.net/Pages/Accessibility.aspx'>
                    Accessibility
                </a>
            </li>
            <li class='nav-item py-0 px-2 text-center'>
                <a class='nav-link' href='https://www.isbe.net/Pages/Privacy-Policy.aspx'>
                    Privacy Policy
                </a>
            </li>
            <li class='nav-item py-0 px-2 text-center'>
                <a class='nav-link' href='https://www.isbe.net/Pages/Careers-at-ISBE.aspx'>
                    Careers at ISBE
                </a>
            </li>
        </ul>
    </footer>
</template>

<script>
export default {
  name: 'Footer'
}
</script>